import React, { useState, useRef } from 'react';
import styles from './ResultsFooter.module.css';

const ResultsFooter = ({ currentPage, setCurrentPage, firstContactIndex, lastContactIndex, totalContactsLength, contactsPerPage }) => {
    const [pageToggleOpen, setPageToggleOpen] = useState(false);
    const totalPages = Math.ceil(totalContactsLength / contactsPerPage);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const customSelectRef = useRef(null);

    const handlePageSelect = (pageNumber) => {
        if (pageNumber !== currentPage) {
            setCurrentPage(pageNumber);
        }
        setPageToggleOpen(false);
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevCaretClass = currentPage > 1 ? styles.caretContainerActive : styles.caretContainerInactive;
    const nextCaretClass = currentPage < totalPages ? styles.caretContainerActive : styles.caretContainerInactive;

    return (
        <div className={styles.resultsFooter}>
            <div className={styles.resultsFooterContent}>
                <div className={styles.pageSelectContainer}>
                    <div className={styles.caretSection} onClick={goToPreviousPage}>
                        <div className={prevCaretClass}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                <path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z" />
                            </svg>
                        </div>
                    </div>

                    <div
                        className={`${styles.pageSelect} ${pageToggleOpen ? styles.pageSelectOpen : ''}`}
                        onClick={() => setPageToggleOpen(!pageToggleOpen)}
                        ref={customSelectRef}
                    >
                        {currentPage}
                    </div>

                    <div className={styles.caretSection} onClick={goToNextPage}>
                        <div className={nextCaretClass}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                <path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" />
                            </svg>
                        </div>
                    </div>
                </div>

                {pageToggleOpen && (
                    <div className={styles.pageSelectOptions}>
                        {pageNumbers.map((number) => (
                            <div key={number} className={styles.pageSelectItem} onClick={() => handlePageSelect(number)}>
                                {number}
                            </div>
                        ))}
                    </div>
                )}

                <div className={styles.text}>
                    Showing results {firstContactIndex + 1} to {lastContactIndex} of {totalContactsLength}
                </div>
            </div>
        </div>
    );
};

export default ResultsFooter;
